export default __webpack_public_path__ + "static/media/client6.7bd70e00.png";